export default __webpack_public_path__ + "static/media/PTSans-Bold.00fb87f6.ttf";